import { render } from "./HeaderUserAvatarDropdown.vue?vue&type=template&id=1188e426&scoped=true"
import script from "./HeaderUserAvatarDropdown.vue?vue&type=script&lang=js"
export * from "./HeaderUserAvatarDropdown.vue?vue&type=script&lang=js"

import "./HeaderUserAvatarDropdown.vue?vue&type=style&index=0&id=1188e426&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1188e426"]])

export default __exports__